import api from "../api/client";

const productApi = {
  create(payload) {
    return api.post("/v1/product", payload);
  },

  update(id, payload) {
    return api.patch(`/v1/product/${id}`, payload);
  },

  getById(id) {
    return api.get(`/v1/product/${id}`);  
  },

  getAll(params = {}) {
    return api.get("/v1/product", { params });
  },

  delete(id) {
    return api.delete(`/v1/product/${id}`);
  },
};

export default productApi;
